import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import {
  IconCircleCheck,
  IconInfoCircle,
  IconAlertTriangle,
  IconAlertOctagon,
  IconLoader,
} from "@tabler/icons-react"

const Toaster = ({ position, ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      {...props}
      theme={theme as ToasterProps["theme"]}
      position={position ?? "bottom-right"}
      expand={false}
      className="toaster group"
      icons={{
        success: <IconCircleCheck className="size-3.5" />,
        info: <IconInfoCircle className="size-3.5" />,
        warning: <IconAlertTriangle className="size-3.5" />,
        error: <IconAlertOctagon className="size-3.5" />,
        loading: <IconLoader className="size-3.5 animate-spin" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-xs shadow-md w-auto",
          default: "bg-popover text-popover-foreground border-border",
          success:
            "bg-emerald-50 dark:bg-emerald-950 text-emerald-900 dark:text-emerald-100 border-emerald-200 dark:border-emerald-800 [&>svg]:text-emerald-600 dark:[&>svg]:text-emerald-400",
          error:
            "bg-red-50 dark:bg-red-950 text-red-900 dark:text-red-100 border-red-200 dark:border-red-800 [&>svg]:text-red-600 dark:[&>svg]:text-red-400",
          warning:
            "bg-amber-50 dark:bg-amber-950 text-amber-900 dark:text-amber-100 border-amber-200 dark:border-amber-800 [&>svg]:text-amber-600 dark:[&>svg]:text-amber-400",
          info: "bg-sky-50 dark:bg-sky-950 text-sky-900 dark:text-sky-100 border-sky-200 dark:border-sky-800 [&>svg]:text-sky-600 dark:[&>svg]:text-sky-400",
          title: "font-medium",
          description: "text-[10px] opacity-80",
          actionButton:
            "bg-primary text-primary-foreground text-[10px] font-medium px-1.5 py-0.5 rounded hover:bg-primary/90",
          cancelButton:
            "bg-muted text-muted-foreground text-[10px] font-medium px-1.5 py-0.5 rounded hover:bg-muted/80",
          closeButton:
            "text-muted-foreground hover:text-foreground transition-colors",
        },
      }}
    />
  )
}

export { Toaster }
